
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "37px",
    "height": "40px",
    "viewBox": "0 0 37 40",
    "enable-background": "new 0 0 37 40",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#999999",
        "width": "37",
        "height": "40"
      }
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M4.916,18.428h4.375c0-0.083,0.021-0.25,0.063-0.5c0.083-0.5,0.146-0.875,0.188-1.125H3.166V15.74h4.688\r\n\t\t\tc-0.5-0.708-0.938-1.271-1.313-1.688l1-0.625c0.125,0.167,0.291,0.375,0.5,0.625c0.291,0.334,0.604,0.709,0.938,1.125L8.103,15.74\r\n\t\t\th3.75c0.708-0.958,1.229-1.708,1.563-2.25l1.063,0.625c-0.167,0.25-0.438,0.604-0.813,1.063c-0.209,0.25-0.354,0.438-0.438,0.563\r\n\t\t\th4.625v1.063h-7.063c-0.125,0.625-0.25,1.167-0.375,1.625h5.688v9.938h-1.188v-0.938H6.103v0.938H4.916V18.428z M6.103,19.49\r\n\t\t\tv1.688h8.813V19.49H6.103z M6.103,22.178v1.625h8.813v-1.625H6.103z M6.103,24.803v1.688h8.813v-1.688H6.103z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M18.916,27.303c5.041-0.833,7.396-2.979,7.063-6.438v-1.5h1.125v1.5c0.041,1-0.063,1.896-0.313,2.688\r\n\t\t\tc0.5,0.25,1.229,0.646,2.188,1.188c1.958,1.084,3.416,1.854,4.375,2.313l-0.75,1.188c-2-1.25-4.084-2.458-6.25-3.625\r\n\t\t\tc-0.875,1.667-3.104,2.916-6.688,3.75C19.541,28.073,19.291,27.719,18.916,27.303z M20.978,17.428h4.25l0.563-2.063h-6.5v-1.063\r\n\t\t\th14.438v1.063h-6.688l-0.625,2.063h5.688v7.188h-1.188V18.49h-8.75v6.188h-1.188V17.428z"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  